if (!customElements.get("show-more")) {
  customElements.define(
    "show-more",
    class ShowMore extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest(".section");
        this.collectionBlock = this.section.querySelector(".collection-block");
        this.init();
      }
      init() {
        this.handleLineToShow();
        this.addEventListener("click", this.handleClick.bind(this));
      }

      handleLineToShow() {
        const collectionDesc = this.collectionBlock.querySelector(
          ".collection-block__description"
        );
        const computedStyle = getComputedStyle(collectionDesc);
        const lineClamp = computedStyle.getPropertyValue("-webkit-line-clamp");
        const paragraphDesc = collectionDesc.querySelectorAll("p");
        const paragraphDescStyle = getComputedStyle(paragraphDesc[0]);
        const lineHeight = parseFloat(paragraphDescStyle.lineHeight);
        let totalMargin = 0;

        paragraphDesc.forEach((p) => {
          const marginBottom =
            parseFloat(getComputedStyle(p).marginBottom) || 0;
          totalMargin += marginBottom;
        });

        const numberOfLines = Math.round(
          (collectionDesc.scrollHeight - totalMargin) / lineHeight
        );

        if (numberOfLines <= lineClamp) {
          this.hidden = true;
        }
      }

      handleClick() {
        if (this.collectionBlock) {
          this.collectionBlock.classList.toggle("expanded");
        }
      }
    }
  );
}
